module.exports = __webpack_public_path__ + "static/icons/icon-share-64dea7eed3bfb9744567cff7e02c97cd.svg";